import React from "react";
import TopCaldaieReportStore from "../TopCaldaieReportStore";
import { Loading } from "../../common/components/loading";
import { GetTable } from "../../common/components/DataTable";
import { ImpiantiByModello } from "../../generated";

const Table = GetTable<ImpiantiByModello>();

export default () => {
    let items = TopCaldaieReportStore.useAll()
    if (!items)
        return <Loading />

    return <div className="card">
        <div className="card-header bg-theme d-flex">
            <div className="flex-fill"><h3 className="text-white mb-0">Report installazioni</h3></div>
        </div>
        <div className="card-body">
            <Table data={items} keySelector={x => `${x.marca}-${x.modello}`}
                filterables={[
                    x => x.marca, x => x.modello
                ]}>
                <Table.Column
                    header="Marca"
                    template={x => x.marca}
                />
                <Table.Column
                    header="Modello"
                    template={x => x.modello}
                />
                <Table.Column
                    header="Nr.Installazioni"
                    template={x => <span style={{ fontSize: "1rem" }} className="badge badge-theme text-white">{x.tot}</span>}
                    orderBy={x => x.tot}
                    groupable={false}
                />
            </Table>
        </div>
    </div>
}